<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<ng-select id="profile" [items]="allProfiles" bindLabel="name" bindValue="id" [clearable]="true"
				placeholder="Profile" formControlName="profile" [multiple]="false" appearance="outline">
			</ng-select>
			<p *ngIf="showError('profile')" class="text-danger">
				<span *ngIf="f.profile.errors?.required">
					Required
				</span>
				<span *ngIf="f.profile.errors?.incorrect">
					{{customError.profile}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2" *ngIf="uId">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Question*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2" *ngIf="!uId">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<table class="table">
				<thead>
					<tr>
						<th style="width: 90%;">
							<span style="color: #b40a09;">*&nbsp;</span>
							Question
						</th>
						<th style="width: 10%;">Remove</th>
					</tr>
				</thead>
				<tbody>
					<tr formArrayName="questions" *ngFor="let creds of get_rows.controls; let i = index">
						<ng-container [formGroupName]="i">
							<td>
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'question_name')}"
										id="question_name" formControlName="question_name" placeholder="">
									<label for="question_name">Question*</label>
								</div>
								<p *ngIf="showError2(i,'question_name')" class="text-danger">
									<span *ngIf="creds.get('question_name')?.errors?.required">
										Required
									</span>
								</p>
							</td>
							<td>
								<button type="button" (click)="deleteRow(i)" class="btn btn-sm btn-danger"
									matTooltip="Remove">
									<fa-icon [icon]="['fas', 'times']"></fa-icon>
								</button>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="button" (click)="addRow()" class="btn btn-primary me-1" *ngIf="!uId">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Add
			</button>
			<button type="submit" class="btn btn-success me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>